module.exports = __webpack_public_path__ + "static/device.891ee785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/device.png
// module id = 469
// module chunks = 35783957827783